import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import '../Card/card-style.css';
import './practice-card.css';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { Auth } from 'aws-amplify';
import { SubscriptionContext } from '../../reducers/SubscriptionContext';
import { LocationContext } from '../../reducers/LocationContext';

// Input styles
const inputStyles = {
  width: 72,
  minWidth: 60,
  flexShrink: 0,
  textAlign: 'center',
  fontWeight: 'bold',
  padding: '4px 6px',
  boxSizing: 'border-box',
  border: '1px solid #e0e0e0',
  borderRadius: '4px',
  backgroundColor: '#fff',
  transition: 'border-color 0.2s',
};

const focusCSS = `
input[type="number"]:focus {
  border-color: #80bfff !important;
  outline: none;
}
`;

function PracticeCard(props) {
  const { name, totalquestions, category } = props.event;
  const event_copy = props.event;

  const noofquestions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100];
  const timeOptions = [0, 5, 10, 15, 30, 45, 60, 90, 120, 180, 300];

  const formatTimeDisplay = (seconds) => {
    if (seconds === 0) return 'No time limit';
    if (seconds >= 60) {
      const minutes = seconds / 60;
      return `${minutes === Math.floor(minutes) ? minutes : minutes.toFixed(1)} min`;
    }
    return `${seconds} sec`;
  };
  
  const formatTotalTime = (seconds) => {
    if (seconds === 0) return 'No time limit';
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    if (m > 0 && s > 0) return `${m} min ${s} sec`;
    if (m > 0) return `${m} min`;
    return `${s} sec`;
  };

  const [noofquestion, set_noofquestion] = useState();
  const [value, setValue] = useState([1, totalquestions]);
  const [inputStart, setInputStart] = useState('1');
  const [inputEnd, setInputEnd] = useState(String(totalquestions));
  const [random, setRandom] = useState(true);
  const [timePerQuestion, setTimePerQuestion] = useState(60);

  const { subscriptionStatus } = useContext(SubscriptionContext);
  const { countryCode } = useContext(LocationContext);

  // Keep string inputs in sync with slider
  useEffect(() => {
    setInputStart(String(value[0]));
    setInputEnd(String(value[1]));
  }, [value[0], value[1]]);

  useEffect(() => {
    Auth.currentAuthenticatedUser().catch(() => { });
  }, []);

  function setQuestionNo(questionnumber) {
    event_copy.start_limit = 0;
    event_copy.end_limit = questionnumber - 1;
    event_copy.randomize = random;
    event_copy.timePerQuestion = parseInt(timePerQuestion);
    event_copy.time = parseInt(timePerQuestion);
  }

  function randomme() {
    setRandom(prev => {
      const newVal = !prev;
      event_copy.randomize = newVal;
      return newVal;
    });
  }

  function handleTimeChange(time) {
    const parsedTime = parseInt(time);
    setTimePerQuestion(parsedTime);
    event_copy.timePerQuestion = parsedTime;
    event_copy.time = parsedTime;
  }

  function handleChange(change) {
    setValue(change);
    // `useEffect` will sync string inputs
    event_copy.start_limit = change[0] - 1;
    event_copy.end_limit = change[1] - 1;
    event_copy.randomize = random;
    event_copy.timePerQuestion = parseInt(timePerQuestion);
    event_copy.time = parseInt(timePerQuestion);
  }

  // Typing in the left box
  function handleStartInputChange(e) {
    setInputStart(e.target.value);
  }
  function handleStartBlur() {
    let val = parseInt(inputStart, 10);
    if (isNaN(val)) val = 1;
    if (val < 1) val = 1;
    if (val >= value[1]) val = value[1] - 1;
    setValue([val, value[1]]);
    setInputStart(String(val));
  }
  // Typing in the right box
  function handleEndInputChange(e) {
    setInputEnd(e.target.value);
  }
  function handleEndBlur() {
    let val = parseInt(inputEnd, 10);
    if (isNaN(val)) val = value[0];
    if (val < value[0]) val = value[0];
    if (val > totalquestions) val = totalquestions;
    setValue([value[0], val]);
    setInputEnd(String(val));
  }

  const numQuestions = value[1] - value[0] + 1;
  const totalTimeInSeconds =
    timePerQuestion === 0 ? 0 : timePerQuestion * numQuestions;

  return (
    <div className="card text-center shadow">
      {/* Only needed if you haven't added the focus effect to your CSS */}
      <style>{focusCSS}</style>

      <div className="overflow">
        <Link to={{ pathname: '/practicequiz', state: event_copy }}>
          <img
            src={'../assets/' + category + '.png'}
            alt=""
            className="card-img-top"
            width="200"
            height="250"
            onClick={() => {
              // Update event_copy with latest values before navigation
              event_copy.start_limit = value[0] - 1;
              event_copy.end_limit = value[1] - 1;
              event_copy.randomize = random;
              event_copy.timePerQuestion = parseInt(timePerQuestion);
              event_copy.time = parseInt(timePerQuestion);
            }}
          />
        </Link>
      </div>
      <div className="card-body text-dark">
        <h4 className="card-text">{name}</h4>

        {(['SpellBowl', 'Spanish', 'Invitational', 'ScienceBowl'].includes(category)) && (
          <>
            <h5 className="card2-text">Shuffle</h5>
            <div className="ct-input">
              <label className="switch">
                <input type="checkbox" onChange={randomme} defaultChecked={true} />
                <span className="slider round"></span>
              </label>
            </div>
          </>
        )}

        <>
            {/* Slider row */}
            <div
              className="ct-input-range"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                marginBottom: '4px',
                flexWrap: 'nowrap',
                maxWidth: '430px',
                width: '100%',
                margin: '0 auto',
                boxSizing: 'border-box'
              }}
            >
              <span className="ct-input-label">QNo:</span>

              {/* Lower bound */}
              <input
                type="number"
                min={1}
                max={value[1] - 1}
                value={inputStart}
                onChange={handleStartInputChange}
                onBlur={handleStartBlur}
                style={inputStyles}
              />

              {/* Slider */}
              <Slider
                trackStyle={{ height: 10 }}
                handleStyle={{ height: 20, width: 20 }}
                railStyle={{ height: 10 }}
                value={value}
                range={[1, totalquestions]}
                min={1}
                max={totalquestions}
                onChange={handleChange}
                style={{ flex: '1 1 0', minWidth: 80 }}
              />

              {/* Upper bound */}
              <input
                type="number"
                min={value[0] + 1}
                max={totalquestions}
                value={inputEnd}
                onChange={handleEndInputChange}
                onBlur={handleEndBlur}
                style={inputStyles}
              />
            </div>

            {/* Timer select */}
            <div className="add-item-box-gray mt-2">
              <select
                name="timePerQuestion"
                value={timePerQuestion}
                onChange={(e) => handleTimeChange(e.target.value)}
                required
              >
                <option value="" disabled>
                  Time per Question
                </option>
                {timeOptions.map((time) => (
                  <option key={time} value={time}>
                    {formatTimeDisplay(time)}
                  </option>
                ))}
              </select>
            </div>

            {/* Total time */}
            <div
              className="total-time-display"
              style={{ marginTop: '6px', fontWeight: '500' }}
            >
              Total Session Time: {formatTotalTime(totalTimeInSeconds)}
            </div>
          </>
      </div>
    </div>
  );
}

export default PracticeCard;
